<template>
  <div
    style="
      margin-bottom: 10px;
      border: none;
      box-shadow: none;
      border-bottom: 1px solid #b7b7b7;
    "
  >
    <!-- Card content -->
    <div class="card-body" style="padding: 0">
      <!-- title -->
      <div style="d-flex flex-row">
        <div style="width: 100%">
          <div class="card-user-name">
            <div
              style="display: flex; align-items: center"
              @click="
                $router.push({
                  name: 'profile',
                  params: {
                    id: video.competition_id,
                    userId: video.user_id._id
                  }
                })
              "
            >
              <div class="card-main-image">
                <figure class="image user-image">
                  <img
                    class="is-rounded"
                    v-lazysizes
                    :src="
                      video.user_id.avatar !== '' && video.user_id.avatar
                        ? video.user_id.avatar
                        : defaultImage
                    "
                    @error="userImageErrorHandler"
                    :style="{
                      border: '2px solid ' + color,
                      objectFit: 'cover',
                      height: '45px',
                      padding: '2px'
                    }"
                  />
                </figure>
              </div>
              <div class="card-main-title" :style="cssVariable">
                {{ video.user_id.name }}
              </div>
            </div>
          </div>
          <div class="card-edit-menu">
            <div
              v-bind:class="
                isOpen
                  ? lang === 'ar'
                    ? 'is-active dropdown is-left'
                    : 'is-active dropdown is-right'
                  : 'dropdown is-right'
              "
            >
              <div class="dropdown-trigger">
                <a
                  role="button"
                  @click="isOpen = !isOpen"
                  aria-haspopup="true"
                  aria-controls="dropdown-menu2"
                >
                  <div class="icon is-small">
                    <svg
                      width="24px"
                      height="24px"
                      viewBox="0 0 24 24"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                    >
                      <g
                        id="Icons/side-menu"
                        stroke="none"
                        stroke-width="1"
                        fill="none"
                        fill-rule="evenodd"
                      >
                        <g
                          id="more-horizontal"
                          transform="translate(4.000000, 11.000000)"
                          fill="#111111"
                        >
                          <path
                            d="M8,-0.75 C8.96649831,-0.75 9.75,0.0335016878 9.75,1 C9.75,1.96649831 8.96649831,2.75 8,2.75 C7.03350169,2.75 6.25,1.96649831 6.25,1 C6.25,0.0335016878 7.03350169,-0.75 8,-0.75 Z M15,-0.75 C15.9664983,-0.75 16.75,0.0335016878 16.75,1 C16.75,1.96649831 15.9664983,2.75 15,2.75 C14.0335017,2.75 13.25,1.96649831 13.25,1 C13.25,0.0335016878 14.0335017,-0.75 15,-0.75 Z M1,-0.75 C1.96649831,-0.75 2.75,0.0335016878 2.75,1 C2.75,1.96649831 1.96649831,2.75 1,2.75 C0.0335016878,2.75 -0.75,1.96649831 -0.75,1 C-0.75,0.0335016878 0.0335016878,-0.75 1,-0.75 Z"
                            id="Combined-Shape"
                          ></path>
                        </g>
                      </g>
                    </svg>

                    <!-- <img :src="menuImg" alt="menu"/> -->
                    <!-- <i class="fas fa-ellipsis-h"></i> -->
                  </div>
                </a>
              </div>
              <div class="dropdown-menu" id="dropdown-menu2" role="menu">
                <a
                  role="button"
                  @click="reportMethod(video._id)"
                  class="dropdown-item"
                  style="text-align: start; padding: 10px"
                >
                  {{ $t("menuCardReport") }}
                </a>
                <a
                  role="button"
                  @click="deleteMethod(video._id)"
                  class="dropdown-item"
                  style="text-align: start; padding: 10px"
                  v-if="currentUser === video.user_id._id"
                >
                  {{ $t("menuCardDelete") }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- videos -->
      <div class="view overlay" style="position: relative">
        <div
          :class="lang === 'ar' ? 'ribbon-left' : 'ribbon-right'"
          v-if="video.isFeatured"
        >
          <svg
            width="24px"
            height="24px"
            viewBox="0 0 24 24"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <g
              id="Icons/award-4"
              stroke="none"
              stroke-width="1"
              fill="none"
              fill-rule="evenodd"
            >
              <g
                id="medal-with-a-star-hanging-of-a-gross-ribbon"
                transform="translate(6.541899, 0.000000)"
                fill="#FCB434"
              >
                <path
                  d="M5.26364246,13.9541899 C8.0190838,13.9541899 10.2536313,16.187933 10.2536313,18.9451173 C10.2536313,21.7013631 8.0190838,23.9351061 5.26364246,23.9351061 C2.50739665,23.9351061 0.273251397,21.7005587 0.273251397,18.9451173 C0.273251397,16.187933 2.50739665,13.9541899 5.26364246,13.9541899 Z M5.26364246,16.1750615 L4.36317318,17.9974525 L2.35025698,18.2912179 L3.80715084,19.7111061 L3.46471508,21.7153073 L5.26364246,20.7689832 L7.06310615,21.7169162 L6.72026816,19.7120447 L8.17675978,18.2921564 L6.16424581,17.9990615 L5.26364246,16.1750615 Z M8.07043575,2.39808173e-14 L10.4479106,11.6621229 L5.26364246,13.7631285 L2.45711732,2.39808173e-14 L8.07043575,2.39808173e-14 Z M2.17099441,1.40540782 L4.63977654,13.5109274 L0.0793743017,11.6621229 L2.17099441,1.40540782 Z"
                  id="Combined-Shape"
                ></path>
              </g>
            </g>
          </svg>
        </div>
        <div
          :class="lang === 'ar' ? 'ribbon-right' : 'ribbon-left'"
          :style="cssVariable"
          v-if="isRanking"
          style="display: flex; justify-content: center; align-items: center"
        >
          <div
            style="display: flex; justify-content: center; align-items: center"
          >
            <svg
              width="24px"
              height="24px"
              viewBox="0 0 24 24"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              style="width: 22px; height: 22px"
            >
              <g
                id="Icons/award-3"
                stroke="none"
                stroke-width="1"
                fill="none"
                fill-rule="evenodd"
              >
                <g
                  id="award-star-with-olive-branches"
                  transform="translate(2.000000, 1.000000)"
                  :fill="color"
                >
                  <path
                    d="M12.145019,18.1287016 C12.145019,18.1287016 12.6713201,17.5128174 13.6094549,17.6478142 C14.5475896,17.7852995 15.0303433,18.4515743 15.0303433,18.4515743 C15.0303433,18.4515743 14.3957959,19.158908 13.4806791,19.0263996 C12.5668064,18.893269 12.145019,18.1287016 12.145019,18.1287016 Z M6.38992303,17.6353721 C7.32743569,17.5003753 7.85498098,18.1175037 7.85498098,18.1175037 C7.85498098,18.1175037 7.4338157,18.881449 6.51869882,19.0145796 C5.60420405,19.147088 4.96903456,18.4403764 4.96903456,18.4403764 C4.96903456,18.4403764 5.45178826,17.7728574 6.38992303,17.6353721 Z M17.8497245,11.1275287 L17.8494442,11.1900521 C17.8364033,11.7700668 17.5086098,16.2122058 10.5704705,18.2836058 L10.5704705,18.2836058 L10.4410726,17.8512427 C17.0260571,15.8836039 17.3850196,11.8928892 17.3973076,11.2328492 L17.3972455,11.1579026 L17.3972455,11.1579026 L17.3968318,11.1455698 L17.8497245,11.1275287 L17.8497245,11.1275287 Z M2.1496534,11.1157087 L2.60192394,11.1337498 L2.60192394,11.1337498 L2.6014482,11.2208259 C2.61373618,11.880058 2.97269869,15.872406 9.55768314,17.8400448 L9.55768314,17.8400448 L9.42828524,18.2730301 C2.4907298,16.2004624 2.1629722,11.7582515 2.14993356,11.1782324 L2.1496534,11.1157087 Z M15.6736002,16.5379784 C16.4963552,16.5584664 17.0256645,17.015852 17.1521869,17.1374573 L17.1815834,17.1669269 C17.1815834,17.1669269 16.6341308,17.9439364 15.7115486,17.9215406 C14.7871002,17.8997669 14.2763517,17.191189 14.2763517,17.191189 C14.2763517,17.191189 14.726756,16.5149605 15.6736002,16.5379784 Z M4.32577769,16.5249142 C5.27262194,16.5018963 5.72302616,17.1775027 5.72302616,17.1775027 C5.72302616,17.1775027 5.21165562,17.8867027 4.28782927,17.9078543 C3.36524713,17.9308722 2.81779448,17.1532405 2.81779448,17.1532405 L2.81779448,17.1532405 L2.84724854,17.1237725 C2.97400097,17.0021768 3.50410103,16.544863 4.32577769,16.5249142 Z M12.6495464,14.656732 C12.6495464,14.656732 12.9991696,15.4051247 12.6619885,16.2916247 C12.3235632,17.1762584 11.5278906,17.3367616 11.5278906,17.3367616 C11.5278906,17.3367616 11.0656664,16.5958342 11.3947601,15.7323521 C11.725098,14.8688699 12.6495464,14.656732 12.6495464,14.656732 Z M7.34858727,14.6442899 C7.34858727,14.6442899 8.27552415,14.8558057 8.60461784,15.7192879 C8.93371154,16.5833921 8.47148731,17.3243195 8.47148731,17.3243195 C8.47148731,17.3243195 7.67519255,17.1638163 7.33676727,16.2785605 C6.99958621,15.3920605 7.34858727,14.6442899 7.34858727,14.6442899 Z M16.9719339,15.023152 C17.8826961,14.7575131 18.6006056,15.1668584 18.6006056,15.1668584 C18.6006056,15.1668584 18.313815,16.0726437 17.427315,16.3308174 C16.5395708,16.5889911 15.837836,16.068911 15.837836,16.068911 C15.837836,16.068911 16.0630381,15.2881689 16.9719339,15.023152 Z M1.39939443,15.1525499 C1.39939443,15.1525499 2.11605972,14.7444489 3.02682185,15.0094657 C3.93571768,15.2744826 4.16091979,16.0552247 4.16091979,16.0552247 C4.16091979,16.0552247 3.46042924,16.5759268 2.572685,16.3165089 C1.68618496,16.0577131 1.39939443,15.1525499 1.39939443,15.1525499 Z M14.0020033,13.2992983 C14.0020033,13.2992983 14.5500781,13.9139383 14.4822686,14.8601605 C14.4125928,15.8070047 13.6971717,16.1883552 13.6971717,16.1883552 C13.6971717,16.1883552 13.042717,15.6104194 13.1086601,14.6903257 C13.1770917,13.7689878 14.0020033,13.2992983 14.0020033,13.2992983 Z M5.99737459,13.2881004 C5.99737459,13.2881004 6.82353041,13.7571678 6.89071778,14.6772615 C6.95728305,15.5979773 6.30220618,16.1771574 6.30220618,16.1771574 C6.30220618,16.1771574 5.58554089,15.7945626 5.51710931,14.8483405 C5.45723168,14.0203961 5.86984301,13.4467956 5.97393143,13.3163321 Z M15.4571076,11.9555509 C15.4571076,11.9555509 16.0605497,12.517312 16.0817013,13.4641562 C16.1016086,14.4116226 15.424136,14.8607826 15.424136,14.8607826 C15.424136,14.8607826 14.7174244,14.3450573 14.6968949,13.4224751 C14.6788539,12.499893 15.4571076,11.9555509 15.4571076,11.9555509 Z M4.54289244,11.9431088 C4.54289244,11.9431088 5.32114615,12.4874509 5.30248299,13.410033 C5.28195351,14.3338594 4.57524191,14.8483405 4.57524191,14.8483405 C4.57524191,14.8483405 3.89776925,14.3998026 3.91829873,13.4517141 C3.93609094,12.6294983 4.39218259,12.0993263 4.51349073,11.9725643 Z M18.1078982,13.220913 C18.9371645,12.7605551 19.7266161,12.9994436 19.7266161,12.9994436 C19.7266161,12.9994436 19.6494751,13.9462878 18.8419824,14.3948257 C18.0338677,14.8433636 17.2344624,14.4924962 17.2344624,14.4924962 C17.2344624,14.4924962 17.2804982,13.6806488 18.1078982,13.220913 Z M0.27213965,12.9870014 C0.27213965,12.9870014 1.06159126,12.7487351 1.8908576,13.2078488 C2.71825763,13.6682067 2.76429342,14.4800541 2.76429342,14.4800541 L2.76429342,14.4800541 L2.73241043,14.4927262 C2.57620667,14.551409 1.87036472,14.7775302 1.15677337,14.3817615 C0.444279842,13.9859928 0.30039916,13.2027536 0.276406384,13.0239398 Z M19.9686151,10.5421277 C19.9686151,10.5421277 20.1739098,11.4690646 19.5343856,12.1359614 C18.8954835,12.8028583 18.0270245,12.7033214 18.0270245,12.7033214 C18.0270245,12.7033214 17.8310613,11.915114 18.4861382,11.2301761 C19.1437035,10.5458603 19.9686151,10.5421277 19.9686151,10.5421277 Z M0.0313849049,10.5303077 C0.0313849049,10.5303077 0.856296514,10.5327961 1.5132397,11.217734 C2.16769446,11.9014277 1.9729755,12.6902572 1.9729755,12.6902572 C1.9729755,12.6902572 1.10451652,12.7897941 0.465614394,12.1241414 C-0.173909839,11.4566224 0.0313849049,10.5303077 0.0313849049,10.5303077 Z M16.2303844,9.67677922 C16.2303844,9.67677922 16.9022581,10.153934 17.0472087,11.0914466 C17.1896708,12.0283372 16.5775192,12.5602372 16.5775192,12.5602372 C16.5775192,12.5602372 15.8104634,12.1434267 15.6698676,11.229554 C15.5468463,10.4315485 16.068258,9.84120943 16.2005331,9.7060935 Z M3.76961557,9.6624708 C3.76961557,9.6624708 4.47072822,10.3044835 4.32951032,11.2164898 C4.18891453,12.1309846 3.42185871,12.547173 3.42185871,12.547173 C3.42185871,12.547173 2.809085,12.0146509 2.95279133,11.0771382 C3.09774186,10.1402477 3.76961557,9.6624708 3.76961557,9.6624708 Z M18.1222066,7.80735284 C18.1222066,7.80735284 18.8077666,8.46554023 18.6460193,9.37568027 C18.4836498,10.2845761 17.7072624,10.6827235 17.7072624,10.6827235 C17.7072624,10.6827235 17.1063087,10.1358929 17.2730329,9.20211289 C17.4378908,8.26957707 18.1222066,7.80735284 18.1222066,7.80735284 Z M1.87779339,7.79491073 C1.87779339,7.79491073 2.5614871,8.25713496 2.72758921,9.18967078 C2.89369132,10.1228287 2.29273762,10.6696593 2.29273762,10.6696593 C2.29273762,10.6696593 1.51635022,10.2715119 1.35460285,9.36323816 C1.19285547,8.45309813 1.87779339,7.79491073 1.87779339,7.79491073 Z M8.08071067,3.63282812 L4.59278638,4.14307963 L4.53682655,4.15515483 C4.24969929,4.23813164 4.14675181,4.60913862 4.37088674,4.82744605 L6.89372528,7.28525545 L6.29878485,10.7575314 L6.29304473,10.8113808 C6.28064396,11.1118084 6.60296156,11.326615 6.88093454,11.1804318 L10.0000002,9.53993928 L13.119066,11.1804318 L13.1685032,11.2025376 C13.4503815,11.3072042 13.7543067,11.0670792 13.7012157,10.7575314 L13.1057403,7.28525545 L15.6291138,4.82744605 L15.6673409,4.78483156 C15.8511488,4.54915829 15.7168056,4.18833106 15.4072141,4.14307963 L11.9187549,3.63282812 L10.3597496,0.473613318 C10.2125792,0.175462227 9.78742129,0.175462227 9.64025086,0.473613318 L8.08071067,3.63282812 Z"
                    id="Combined-Shape"
                  ></path>
                </g>
              </g>
            </svg>
            <div class="ribbon-text" v-if="lang === 'ar'">
              {{ $t("RankTitle") + " " }} {{ rankingNum | arabicize }}
            </div>
            <div class="ribbon-text" v-else>
              {{ $t("RankTitle") + " " }}{{ rankingNum }}
            </div>
          </div>
          <div
            v-if="video.winnerLogo"
            style="
              margin: auto 2px;
              display: flex;
              justify-content: center;
              align-items: center;
            "
          >
            <div class="ribbon-text">-</div>
            <div style="width: 20px; display: inline-block; margin: 0 8px">
              <img v-lazysizes :src="video.winnerLogo" alt="prize" />
            </div>
            <div class="ribbon-text">{{ $t("GiftTitle") }}</div>
            <!-- <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <g id="Icons/price" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="gift" transform="translate(2.000000, 2.000000)" :fill="color">
                  <path d="M14.5,-0.75 C16.2949254,-0.75 17.75,0.705074563 17.75,2.5 C17.75,3.14497796 17.5621193,3.74607404 17.2381016,4.25154453 L20,4.25 C20.4142136,4.25 20.75,4.58578644 20.75,5 L20.75,5 L20.75,10 C20.75,10.4142136 20.4142136,10.75 20,10.75 L20,10.75 L18.75,10.75 L18.75,20 C18.75,20.3796958 18.4678461,20.693491 18.1017706,20.7431534 L18,20.75 L2,20.75 C1.62030423,20.75 1.30650904,20.4678461 1.25684662,20.1017706 L1.25,20 L1.25,10.75 L0,10.75 C-0.379695766,10.75 -0.693490961,10.4678461 -0.743153384,10.1017706 L-0.75,10 L-0.75,5 C-0.75,4.58578644 -0.414213562,4.25 0,4.25 L0,4.25 L2.76189842,4.25154453 C2.4378807,3.74607404 2.25,3.14497796 2.25,2.5 C2.25,0.705074563 3.70507456,-0.75 5.5,-0.75 C7.35345427,-0.75 8.7418456,0.360713071 9.71966193,2.13856094 C9.82012416,2.32121953 9.91413538,2.50732991 10.0019623,2.69581298 L10.0924913,2.49892294 L10.0924913,2.49892294 L10.2803381,2.13856094 C11.2581544,0.360713071 12.6465457,-0.75 14.5,-0.75 Z M9.25,10.75 L2.75,10.75 L2.75,19.25 L9.25,19.25 L9.25,10.75 Z M17.25,10.75 L10.75,10.75 L10.75,19.25 L17.25,19.25 L17.25,10.75 Z M9.25,5.75 L0.75,5.75 L0.75,9.25 L9.25,9.25 L9.25,5.75 Z M19.25,5.75 L10.75,5.75 L10.75,9.25 L19.25,9.25 L19.25,5.75 Z M5.5,0.75 C4.53350169,0.75 3.75,1.53350169 3.75,2.5 C3.75,3.46649831 4.53350169,4.25 5.5,4.25 L5.5,4.25 L9.008,4.25 L8.96497644,4.1202559 C8.84981285,3.79607109 8.71633524,3.47505572 8.56399128,3.16607706 L8.56399128,3.16607706 L8.40533807,2.86143906 C7.6644044,1.51428693 6.70904573,0.75 5.5,0.75 Z M14.5,0.75 C13.2909543,0.75 12.3355956,1.51428693 11.5946619,2.86143906 C11.3196904,3.36138727 11.0976369,3.90298124 10.9259442,4.44516878 L10.991,4.25 L14.5,4.25 C15.3671638,4.25 16.0870138,3.6192751 16.2258229,2.79155257 L16.2441988,2.64352721 L16.25,2.5 C16.25,1.53350169 15.4664983,0.75 14.5,0.75 Z" id="Combined-Shape"></path>
                </g>
              </g>
            </svg> -->
          </div>
        </div>
        <div
          :class="lang === 'ar' ? 'ribbon-right' : 'ribbon-left'"
          :style="cssVariable"
          v-if="video.rank"
          style="display: flex; justify-content: center; align-items: center"
        >
          <div
            style="display: flex; justify-content: center; align-items: center"
          >
            <svg
              width="24px"
              height="24px"
              viewBox="0 0 24 24"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              style="width: 22px; height: 22px"
            >
              <g
                id="Icons/award-3"
                stroke="none"
                stroke-width="1"
                fill="none"
                fill-rule="evenodd"
              >
                <g
                  id="award-star-with-olive-branches"
                  transform="translate(2.000000, 1.000000)"
                  :fill="color"
                >
                  <path
                    d="M12.145019,18.1287016 C12.145019,18.1287016 12.6713201,17.5128174 13.6094549,17.6478142 C14.5475896,17.7852995 15.0303433,18.4515743 15.0303433,18.4515743 C15.0303433,18.4515743 14.3957959,19.158908 13.4806791,19.0263996 C12.5668064,18.893269 12.145019,18.1287016 12.145019,18.1287016 Z M6.38992303,17.6353721 C7.32743569,17.5003753 7.85498098,18.1175037 7.85498098,18.1175037 C7.85498098,18.1175037 7.4338157,18.881449 6.51869882,19.0145796 C5.60420405,19.147088 4.96903456,18.4403764 4.96903456,18.4403764 C4.96903456,18.4403764 5.45178826,17.7728574 6.38992303,17.6353721 Z M17.8497245,11.1275287 L17.8494442,11.1900521 C17.8364033,11.7700668 17.5086098,16.2122058 10.5704705,18.2836058 L10.5704705,18.2836058 L10.4410726,17.8512427 C17.0260571,15.8836039 17.3850196,11.8928892 17.3973076,11.2328492 L17.3972455,11.1579026 L17.3972455,11.1579026 L17.3968318,11.1455698 L17.8497245,11.1275287 L17.8497245,11.1275287 Z M2.1496534,11.1157087 L2.60192394,11.1337498 L2.60192394,11.1337498 L2.6014482,11.2208259 C2.61373618,11.880058 2.97269869,15.872406 9.55768314,17.8400448 L9.55768314,17.8400448 L9.42828524,18.2730301 C2.4907298,16.2004624 2.1629722,11.7582515 2.14993356,11.1782324 L2.1496534,11.1157087 Z M15.6736002,16.5379784 C16.4963552,16.5584664 17.0256645,17.015852 17.1521869,17.1374573 L17.1815834,17.1669269 C17.1815834,17.1669269 16.6341308,17.9439364 15.7115486,17.9215406 C14.7871002,17.8997669 14.2763517,17.191189 14.2763517,17.191189 C14.2763517,17.191189 14.726756,16.5149605 15.6736002,16.5379784 Z M4.32577769,16.5249142 C5.27262194,16.5018963 5.72302616,17.1775027 5.72302616,17.1775027 C5.72302616,17.1775027 5.21165562,17.8867027 4.28782927,17.9078543 C3.36524713,17.9308722 2.81779448,17.1532405 2.81779448,17.1532405 L2.81779448,17.1532405 L2.84724854,17.1237725 C2.97400097,17.0021768 3.50410103,16.544863 4.32577769,16.5249142 Z M12.6495464,14.656732 C12.6495464,14.656732 12.9991696,15.4051247 12.6619885,16.2916247 C12.3235632,17.1762584 11.5278906,17.3367616 11.5278906,17.3367616 C11.5278906,17.3367616 11.0656664,16.5958342 11.3947601,15.7323521 C11.725098,14.8688699 12.6495464,14.656732 12.6495464,14.656732 Z M7.34858727,14.6442899 C7.34858727,14.6442899 8.27552415,14.8558057 8.60461784,15.7192879 C8.93371154,16.5833921 8.47148731,17.3243195 8.47148731,17.3243195 C8.47148731,17.3243195 7.67519255,17.1638163 7.33676727,16.2785605 C6.99958621,15.3920605 7.34858727,14.6442899 7.34858727,14.6442899 Z M16.9719339,15.023152 C17.8826961,14.7575131 18.6006056,15.1668584 18.6006056,15.1668584 C18.6006056,15.1668584 18.313815,16.0726437 17.427315,16.3308174 C16.5395708,16.5889911 15.837836,16.068911 15.837836,16.068911 C15.837836,16.068911 16.0630381,15.2881689 16.9719339,15.023152 Z M1.39939443,15.1525499 C1.39939443,15.1525499 2.11605972,14.7444489 3.02682185,15.0094657 C3.93571768,15.2744826 4.16091979,16.0552247 4.16091979,16.0552247 C4.16091979,16.0552247 3.46042924,16.5759268 2.572685,16.3165089 C1.68618496,16.0577131 1.39939443,15.1525499 1.39939443,15.1525499 Z M14.0020033,13.2992983 C14.0020033,13.2992983 14.5500781,13.9139383 14.4822686,14.8601605 C14.4125928,15.8070047 13.6971717,16.1883552 13.6971717,16.1883552 C13.6971717,16.1883552 13.042717,15.6104194 13.1086601,14.6903257 C13.1770917,13.7689878 14.0020033,13.2992983 14.0020033,13.2992983 Z M5.99737459,13.2881004 C5.99737459,13.2881004 6.82353041,13.7571678 6.89071778,14.6772615 C6.95728305,15.5979773 6.30220618,16.1771574 6.30220618,16.1771574 C6.30220618,16.1771574 5.58554089,15.7945626 5.51710931,14.8483405 C5.45723168,14.0203961 5.86984301,13.4467956 5.97393143,13.3163321 Z M15.4571076,11.9555509 C15.4571076,11.9555509 16.0605497,12.517312 16.0817013,13.4641562 C16.1016086,14.4116226 15.424136,14.8607826 15.424136,14.8607826 C15.424136,14.8607826 14.7174244,14.3450573 14.6968949,13.4224751 C14.6788539,12.499893 15.4571076,11.9555509 15.4571076,11.9555509 Z M4.54289244,11.9431088 C4.54289244,11.9431088 5.32114615,12.4874509 5.30248299,13.410033 C5.28195351,14.3338594 4.57524191,14.8483405 4.57524191,14.8483405 C4.57524191,14.8483405 3.89776925,14.3998026 3.91829873,13.4517141 C3.93609094,12.6294983 4.39218259,12.0993263 4.51349073,11.9725643 Z M18.1078982,13.220913 C18.9371645,12.7605551 19.7266161,12.9994436 19.7266161,12.9994436 C19.7266161,12.9994436 19.6494751,13.9462878 18.8419824,14.3948257 C18.0338677,14.8433636 17.2344624,14.4924962 17.2344624,14.4924962 C17.2344624,14.4924962 17.2804982,13.6806488 18.1078982,13.220913 Z M0.27213965,12.9870014 C0.27213965,12.9870014 1.06159126,12.7487351 1.8908576,13.2078488 C2.71825763,13.6682067 2.76429342,14.4800541 2.76429342,14.4800541 L2.76429342,14.4800541 L2.73241043,14.4927262 C2.57620667,14.551409 1.87036472,14.7775302 1.15677337,14.3817615 C0.444279842,13.9859928 0.30039916,13.2027536 0.276406384,13.0239398 Z M19.9686151,10.5421277 C19.9686151,10.5421277 20.1739098,11.4690646 19.5343856,12.1359614 C18.8954835,12.8028583 18.0270245,12.7033214 18.0270245,12.7033214 C18.0270245,12.7033214 17.8310613,11.915114 18.4861382,11.2301761 C19.1437035,10.5458603 19.9686151,10.5421277 19.9686151,10.5421277 Z M0.0313849049,10.5303077 C0.0313849049,10.5303077 0.856296514,10.5327961 1.5132397,11.217734 C2.16769446,11.9014277 1.9729755,12.6902572 1.9729755,12.6902572 C1.9729755,12.6902572 1.10451652,12.7897941 0.465614394,12.1241414 C-0.173909839,11.4566224 0.0313849049,10.5303077 0.0313849049,10.5303077 Z M16.2303844,9.67677922 C16.2303844,9.67677922 16.9022581,10.153934 17.0472087,11.0914466 C17.1896708,12.0283372 16.5775192,12.5602372 16.5775192,12.5602372 C16.5775192,12.5602372 15.8104634,12.1434267 15.6698676,11.229554 C15.5468463,10.4315485 16.068258,9.84120943 16.2005331,9.7060935 Z M3.76961557,9.6624708 C3.76961557,9.6624708 4.47072822,10.3044835 4.32951032,11.2164898 C4.18891453,12.1309846 3.42185871,12.547173 3.42185871,12.547173 C3.42185871,12.547173 2.809085,12.0146509 2.95279133,11.0771382 C3.09774186,10.1402477 3.76961557,9.6624708 3.76961557,9.6624708 Z M18.1222066,7.80735284 C18.1222066,7.80735284 18.8077666,8.46554023 18.6460193,9.37568027 C18.4836498,10.2845761 17.7072624,10.6827235 17.7072624,10.6827235 C17.7072624,10.6827235 17.1063087,10.1358929 17.2730329,9.20211289 C17.4378908,8.26957707 18.1222066,7.80735284 18.1222066,7.80735284 Z M1.87779339,7.79491073 C1.87779339,7.79491073 2.5614871,8.25713496 2.72758921,9.18967078 C2.89369132,10.1228287 2.29273762,10.6696593 2.29273762,10.6696593 C2.29273762,10.6696593 1.51635022,10.2715119 1.35460285,9.36323816 C1.19285547,8.45309813 1.87779339,7.79491073 1.87779339,7.79491073 Z M8.08071067,3.63282812 L4.59278638,4.14307963 L4.53682655,4.15515483 C4.24969929,4.23813164 4.14675181,4.60913862 4.37088674,4.82744605 L6.89372528,7.28525545 L6.29878485,10.7575314 L6.29304473,10.8113808 C6.28064396,11.1118084 6.60296156,11.326615 6.88093454,11.1804318 L10.0000002,9.53993928 L13.119066,11.1804318 L13.1685032,11.2025376 C13.4503815,11.3072042 13.7543067,11.0670792 13.7012157,10.7575314 L13.1057403,7.28525545 L15.6291138,4.82744605 L15.6673409,4.78483156 C15.8511488,4.54915829 15.7168056,4.18833106 15.4072141,4.14307963 L11.9187549,3.63282812 L10.3597496,0.473613318 C10.2125792,0.175462227 9.78742129,0.175462227 9.64025086,0.473613318 L8.08071067,3.63282812 Z"
                    id="Combined-Shape"
                  ></path>
                </g>
              </g>
            </svg>
            <div class="ribbon-text" v-if="lang === 'ar'">
              {{ $t("RankTitle") + " " }} {{ video.rank | arabicize }}
            </div>
            <div class="ribbon-text" v-else>
              {{ $t("RankTitle") + " " }}{{ video.rank }}
            </div>
          </div>
          <div
            v-if="video.winnerLogo"
            style="
              margin: auto 2px;
              display: flex;
              justify-content: center;
              align-items: center;
            "
          >
            <div class="ribbon-text">-</div>
            <img
              v-lazysizes
              :src="video.winnerLogo"
              alt="prize"
              v-if="video.winnerLogo !== ''"
            />
            <svg
              width="24px"
              height="24px"
              viewBox="0 0 24 24"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              v-else
            >
              <g
                id="Icons/price"
                stroke="none"
                stroke-width="1"
                fill="none"
                fill-rule="evenodd"
              >
                <g
                  id="gift"
                  transform="translate(2.000000, 2.000000)"
                  :fill="color"
                >
                  <path
                    d="M14.5,-0.75 C16.2949254,-0.75 17.75,0.705074563 17.75,2.5 C17.75,3.14497796 17.5621193,3.74607404 17.2381016,4.25154453 L20,4.25 C20.4142136,4.25 20.75,4.58578644 20.75,5 L20.75,5 L20.75,10 C20.75,10.4142136 20.4142136,10.75 20,10.75 L20,10.75 L18.75,10.75 L18.75,20 C18.75,20.3796958 18.4678461,20.693491 18.1017706,20.7431534 L18,20.75 L2,20.75 C1.62030423,20.75 1.30650904,20.4678461 1.25684662,20.1017706 L1.25,20 L1.25,10.75 L0,10.75 C-0.379695766,10.75 -0.693490961,10.4678461 -0.743153384,10.1017706 L-0.75,10 L-0.75,5 C-0.75,4.58578644 -0.414213562,4.25 0,4.25 L0,4.25 L2.76189842,4.25154453 C2.4378807,3.74607404 2.25,3.14497796 2.25,2.5 C2.25,0.705074563 3.70507456,-0.75 5.5,-0.75 C7.35345427,-0.75 8.7418456,0.360713071 9.71966193,2.13856094 C9.82012416,2.32121953 9.91413538,2.50732991 10.0019623,2.69581298 L10.0924913,2.49892294 L10.0924913,2.49892294 L10.2803381,2.13856094 C11.2581544,0.360713071 12.6465457,-0.75 14.5,-0.75 Z M9.25,10.75 L2.75,10.75 L2.75,19.25 L9.25,19.25 L9.25,10.75 Z M17.25,10.75 L10.75,10.75 L10.75,19.25 L17.25,19.25 L17.25,10.75 Z M9.25,5.75 L0.75,5.75 L0.75,9.25 L9.25,9.25 L9.25,5.75 Z M19.25,5.75 L10.75,5.75 L10.75,9.25 L19.25,9.25 L19.25,5.75 Z M5.5,0.75 C4.53350169,0.75 3.75,1.53350169 3.75,2.5 C3.75,3.46649831 4.53350169,4.25 5.5,4.25 L5.5,4.25 L9.008,4.25 L8.96497644,4.1202559 C8.84981285,3.79607109 8.71633524,3.47505572 8.56399128,3.16607706 L8.56399128,3.16607706 L8.40533807,2.86143906 C7.6644044,1.51428693 6.70904573,0.75 5.5,0.75 Z M14.5,0.75 C13.2909543,0.75 12.3355956,1.51428693 11.5946619,2.86143906 C11.3196904,3.36138727 11.0976369,3.90298124 10.9259442,4.44516878 L10.991,4.25 L14.5,4.25 C15.3671638,4.25 16.0870138,3.6192751 16.2258229,2.79155257 L16.2441988,2.64352721 L16.25,2.5 C16.25,1.53350169 15.4664983,0.75 14.5,0.75 Z"
                    id="Combined-Shape"
                  ></path>
                </g>
              </g>
            </svg>
            <div class="ribbon-text">{{ $t("GiftTitle") }}</div>
          </div>
        </div>
        <slot></slot>
        <div
          :class="lang === 'ar' ? 'ribbon-right' : 'ribbon-left'"
          v-if="!video.isApproved"
        >
          <div :style="cssVariable">{{ $t("profileVideoNotApprove") }}</div>
        </div>
      </div>

      <!-- buttons and controls -->
      <div class="card-body">
        <div>
          <!-- caption -->
          <div class="card-caption">
            <p style="font-weight: bold; font-size: 15px">
              {{ video.caption }}
            </p>
          </div>
          <div class="card-action-buttons">
            <!-- like button -->
            <div
              class="card-like-button"
              style="
                display: flex;
                justify-content: center;
                align-items: center;
              "
            >
              <svg
                width="24px"
                height="24px"
                viewBox="0 0 24 24"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                style="height: 20px; width: 20px"
                v-if="video.isLiked"
                @click="
                  clickLike({
                    id: video._id,
                    user: video.user_id,
                    isLiked: video.isLiked
                  })
                "
              >
                <g
                  id="Icons/favorites-filled"
                  stroke="none"
                  stroke-width="1"
                  fill="none"
                  fill-rule="evenodd"
                >
                  <path
                    d="M17.25,2 C15.4228563,2.00212494 13.6778916,2.7595689 12.4285714,4.09285714 C10.575025,2.11462434 7.70116276,1.46934993 5.17982124,2.46527982 C2.65847973,3.46120972 1.00133468,5.89623201 1,8.60714286 C1,15.1857143 11.6107143,21.6428571 12.0714286,21.8964286 C12.2978089,22.0324379 12.5807625,22.0324379 12.8071429,21.8964286 C13.2464286,21.6428571 23.8571429,15.1857143 23.8571429,8.60714286 C23.8532061,4.95975052 20.8973923,2.00393675 17.25,2 Z"
                    id="Shape"
                    :fill="color"
                  ></path>
                </g>
              </svg>
              <svg
                width="24px"
                height="24px"
                viewBox="0 0 24 24"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                style="height: 20px; width: 20px"
                v-else
                @click="
                  clickLike({
                    id: video._id,
                    user: video.user_id,
                    isLiked: video.isLiked
                  })
                "
              >
                <g
                  id="Icons/favorites"
                  stroke="none"
                  stroke-width="1"
                  fill="none"
                  fill-rule="evenodd"
                >
                  <g
                    id="love"
                    transform="translate(1.000000, 2.000000)"
                    fill="#111111"
                  >
                    <path
                      d="M16.25,0 C14.4228563,0.00212494249 12.6778916,0.7595689 11.4285714,2.09285714 C9.575025,0.114624338 6.70116276,-0.530650075 4.17982124,0.465279823 C1.65847973,1.46120972 0.0013346838,3.89623201 0,6.60714286 C0,13.1857143 10.6107143,19.6428571 11.0714286,19.8964286 C11.2978089,20.0324379 11.5807625,20.0324379 11.8071429,19.8964286 C12.2464286,19.6428571 22.8571429,13.1857143 22.8571429,6.60714286 C22.8532061,2.95975052 19.8973923,0.00393674639 16.25,0 Z M11.4285714,18.4428571 C9.58214286,17.2642857 1.42857143,11.7571429 1.42857143,6.60714286 C1.43045185,4.34981068 2.89430684,2.35375595 5.04672462,1.67357233 C7.19914241,0.993388715 9.54417786,1.78579939 10.8428571,3.63214286 C10.9766574,3.82206521 11.1944648,3.935051 11.4267857,3.935051 C11.6591066,3.935051 11.876914,3.82206521 12.0107143,3.63214286 C13.308375,1.78253798 15.6554001,0.98774421 17.8098785,1.66832081 C19.9643568,2.34889741 21.4289063,4.34772667 21.4285714,6.60714286 C21.4285714,11.7535714 13.275,17.2607143 11.4285714,18.4428571 Z"
                      id="Shape"
                    ></path>
                  </g>
                </g>
              </svg>
              <div
                v-if="lang === 'ar'"
                class="card-like-number"
                style="margin: 0 4px 0 20px"
              >
                {{ video.likes | arabicize }}
              </div>
              <div v-else class="card-like-number" style="margin: 0 20px 0 4px">
                {{ video.likes ? video.likes : 0 }}
              </div>
            </div>
            <div
              class="card-follow-button"
              style="
                display: flex;
                justify-content: center;
                align-items: center;
              "
            >
              <svg
                width="24px"
                height="24px"
                viewBox="0 0 24 24"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                @click="followHandler(video.user_id._id)"
                v-if="
                  video.user_id.isFollowed ||
                    (video.user && video.user.isFollowed)
                "
                style="height: 20px; width: 20px"
              >
                <g
                  id="Icons/follow-filled"
                  stroke="none"
                  stroke-width="1"
                  fill="none"
                  fill-rule="evenodd"
                >
                  <g
                    id="users"
                    transform="translate(1.000000, 2.000000)"
                    :fill="color"
                  >
                    <path
                      d="M12.75,12 C15.3004817,12 17.3814697,14.0101413 17.4951121,16.532572 L17.5,16.75 L17.5,18.75 C17.5,19.1642136 17.1642136,19.5 16.75,19.5 L0.75,19.5 L0.75,19.5 C0.370304234,19.5 0.0565090391,19.2178461 0.006846616,18.8517706 L0,18.75 L0,16.75 C0,14.1995183 2.01014129,12.1185303 4.532572,12.0048879 L4.75,12 L12.75,12 Z M8.75,0 C11.3733526,0 13.5,2.12664744 13.5,4.75 C13.5,7.37335256 11.3733526,9.5 8.75,9.5 C6.12664744,9.5 4,7.37335256 4,4.75 C4,2.12664744 6.12664744,0 8.75,0 Z M18.75,1 C19.1296958,1 19.443491,1.28215388 19.4931534,1.64822944 L19.5,1.75 L19.5,4 L21.75,4 C22.1642136,4 22.5,4.33578644 22.5,4.75 C22.5,5.12969577 22.2178461,5.44349096 21.8517706,5.49315338 L21.75,5.5 L19.5,5.5 L19.5,7.75 C19.5,8.16421356 19.1642136,8.5 18.75,8.5 C18.3703042,8.5 18.056509,8.21784612 18.0068466,7.85177056 L18,7.75 L18,5.5 L15.75,5.5 C15.3357864,5.5 15,5.16421356 15,4.75 C15,4.37030423 15.2821539,4.05650904 15.6482294,4.00684662 L15.75,4 L18,4 L18,1.75 C18,1.33578644 18.3357864,1 18.75,1 Z"
                      id="Combined-Shape"
                    ></path>
                  </g>
                </g>
              </svg>
              <svg
                width="24px"
                height="24px"
                viewBox="0 0 24 24"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                @click="followHandler(video.user_id._id)"
                v-else
                style="height: 20px; width: 20px"
              >
                <g
                  id="Icons/follow"
                  stroke="none"
                  stroke-width="1"
                  fill="none"
                  fill-rule="evenodd"
                >
                  <g
                    id="users"
                    transform="translate(1.000000, 2.000000)"
                    fill="#111111"
                  >
                    <path
                      d="M12.75,12 C15.3004817,12 17.3814697,14.0101413 17.4951121,16.532572 L17.5,16.75 L17.5,18.75 C17.5,19.1642136 17.1642136,19.5 16.75,19.5 C16.3703042,19.5 16.056509,19.2178461 16.0068466,18.8517706 L16,18.75 L16,16.75 C16,15.0169685 14.6435452,13.6007541 12.9344239,13.5051448 L12.75,13.5 L4.75,13.5 C3.01696854,13.5 1.60075407,14.8564548 1.50514479,16.5655761 L1.5,16.75 L1.5,18.75 C1.5,19.1642136 1.16421356,19.5 0.75,19.5 C0.370304234,19.5 0.0565090391,19.2178461 0.006846616,18.8517706 L0,18.75 L0,16.75 C0,14.1995183 2.01014129,12.1185303 4.532572,12.0048879 L4.75,12 L12.75,12 Z M8.75,0 C11.3733526,0 13.5,2.12664744 13.5,4.75 C13.5,7.37335256 11.3733526,9.5 8.75,9.5 C6.12664744,9.5 4,7.37335256 4,4.75 C4,2.12664744 6.12664744,0 8.75,0 Z M18.75,1 C19.1296958,1 19.443491,1.28215388 19.4931534,1.64822944 L19.5,1.75 L19.5,4 L21.75,4 C22.1642136,4 22.5,4.33578644 22.5,4.75 C22.5,5.12969577 22.2178461,5.44349096 21.8517706,5.49315338 L21.75,5.5 L19.5,5.5 L19.5,7.75 C19.5,8.16421356 19.1642136,8.5 18.75,8.5 C18.3703042,8.5 18.056509,8.21784612 18.0068466,7.85177056 L18,7.75 L18,5.5 L15.75,5.5 C15.3357864,5.5 15,5.16421356 15,4.75 C15,4.37030423 15.2821539,4.05650904 15.6482294,4.00684662 L15.75,4 L18,4 L18,1.75 C18,1.33578644 18.3357864,1 18.75,1 Z M8.75,1.5 C6.95507456,1.5 5.5,2.95507456 5.5,4.75 C5.5,6.54492544 6.95507456,8 8.75,8 C10.5449254,8 12,6.54492544 12,4.75 C12,2.95507456 10.5449254,1.5 8.75,1.5 Z"
                      id="Combined-Shape"
                    ></path>
                  </g>
                </g>
              </svg>
              <div
                v-if="lang === 'ar'"
                class="card-follow-number"
                style="margin: 0 4px 0 20px"
              >
                {{
                  typeof video.user === "undefined"
                    ? video.user_id.followerCount
                    : video.user.followerCount | arabicize
                }}
              </div>
              <div
                v-else
                class="card-follow-number"
                style="margin: 0 20px 0 4px"
              >
                {{
                  typeof video.user === "undefined"
                    ? video.user_id.followerCount
                    : video.user.followerCount
                }}
              </div>
              <!-- <i v-if="video.user_id.isFollowed" @click="followHandler(video.user_id._id)" style="font-size:20px;margin:0 10px" class="fas fa-user-minus"></i>  -->
              <!-- <i v-else @click="followHandler(video.user_id._id)" style="margin: 0 10px; font-size: 20px" class="fas fa-user-plus"></i> -->
            </div>
            <div class="card-share-button">
              <svg
                width="15"
                height="17"
                viewBox="0 0 15 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                @click="shareMethod(video._id)"
              >
                <path
                  d="M11.5222 0C9.96413 0 8.68889 1.27524 8.68889 2.83333C8.68889 3.10859 8.73282 3.37218 8.80694 3.62431L4.58645 6.28056C4.10316 5.89764 3.49401 5.66667 2.83333 5.66667C1.27525 5.66667 0 6.9419 0 8.5C0 10.0581 1.27525 11.3333 2.83333 11.3333C3.49696 11.3333 4.10803 11.0995 4.59236 10.7135L8.80694 13.3698C8.73179 13.6235 8.68889 13.8894 8.68889 14.1667C8.68889 15.7248 9.96413 17 11.5222 17C13.0803 17 14.3556 15.7248 14.3556 14.1667C14.3556 12.6086 13.0803 11.3333 11.5222 11.3333C10.6458 11.3333 9.859 11.7359 9.33819 12.3663L5.33022 9.83992C5.54667 9.44019 5.66667 8.9841 5.66667 8.5C5.66667 8.01497 5.54151 7.56031 5.32431 7.16006C6.65146 6.31482 8.00067 5.47357 9.33819 4.63368C9.859 5.26404 10.6458 5.66667 11.5222 5.66667C13.0803 5.66667 14.3556 4.39143 14.3556 2.83333C14.3556 1.27524 13.0803 0 11.5222 0ZM11.5222 1.13333C12.4678 1.13333 13.2222 1.88774 13.2222 2.83333C13.2222 3.77893 12.4678 4.53333 11.5222 4.53333C10.5766 4.53333 9.82222 3.77893 9.82222 2.83333C9.82222 1.88774 10.5766 1.13333 11.5222 1.13333ZM2.83333 6.8C3.77893 6.8 4.53333 7.5544 4.53333 8.5C4.53333 9.4456 3.77893 10.2 2.83333 10.2C1.88774 10.2 1.13333 9.4456 1.13333 8.5C1.13333 7.5544 1.88774 6.8 2.83333 6.8ZM11.5222 12.4667C12.4678 12.4667 13.2222 13.2211 13.2222 14.1667C13.2222 15.1123 12.4678 15.8667 11.5222 15.8667C10.5766 15.8667 9.82222 15.1123 9.82222 14.1667C9.82222 13.2211 10.5766 12.4667 11.5222 12.4667Z"
                  fill="#313131"
                />
              </svg>
              <!-- <img :src="shareImg" alt="share" style="width:18px" > -->
              <!-- <i class="fas fa-share-alt" :style="{color:color, fontSize: '20px'}" @click="shareMethod(video._id)"></i> -->
            </div>
          </div>
          <!-- comment -->
          <div class="more-comments-view" v-if="video.commentsCount > 0">
            <router-link
              :to="{
                name: 'comments',
                params: {
                  vid: video._id
                }
              }"
            >
              <div class="more-comments-text" v-if="lang === 'ar'">
                {{ $t("moreCommentsTitle1") }}
                {{ video.commentsCount | arabicize }}
                {{ $t("moreCommentsTitle2") }}
              </div>
              <div class="more-comments-text" v-else>
                {{ $t("moreCommentsTitle1") }} {{ video.commentsCount }}
                {{ $t("moreCommentsTitle2") }}
              </div>
            </router-link>
          </div>
          <div class="card-last-comment-container" style="text-align: start">
            <div v-if="video.lastComment && video.lastComment.user_id">
              <div class="card-last-comment-title">
                <div class="card-last-comment-text">
                  <div
                    class="card-last-comment-name"
                    @click="
                      $router.push({
                        name: 'profile',
                        params: {
                          userId: video.lastComment.user_id._id,
                          id: video.competition_id
                        }
                      })
                    "
                  >
                    {{ video.lastComment.user_id.name }}
                  </div>
                  {{
                    video.lastComment.body.length > 50
                      ? video.lastComment.body.substring(0, 50) + "..."
                      : video.lastComment.body
                  }}
                </div>
              </div>
              <div class="last-comment-actions">
                <div class="last-comment-time">
                  <div v-if="lang === 'ar'">
                    {{ getTime(video.lastComment.createdAt) | arabicize }}
                  </div>
                  <div v-else>{{ getTime(video.lastComment.createdAt) }}</div>
                </div>
                <div
                  class="last-comment-delete"
                  style="color: #313131"
                  v-if="currentUser === video.lastComment.user_id._id"
                >
                  <svg
                    width="15px"
                    height="15px"
                    viewBox="0 0 24 24"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    @click="
                      lastCommentDelete(
                        video.lastComment._id,
                        video.lastComment.video_id
                      )
                    "
                  >
                    <g
                      id="Icons/delete"
                      stroke="none"
                      stroke-width="1"
                      fill="none"
                      fill-rule="evenodd"
                    >
                      <g
                        id="trash-2"
                        transform="translate(3.000000, 2.000000)"
                        fill="#111111"
                      >
                        <path
                          d="M11,-0.75 C12.4625318,-0.75 13.6584043,0.391704595 13.7449812,1.83247767 L13.75,2 L13.75,3.25 L18,3.25 C18.4142136,3.25 18.75,3.58578644 18.75,4 C18.75,4.37969577 18.4678461,4.69349096 18.1017706,4.74315338 L18,4.75 L16.75,4.75 L16.75,18 C16.75,19.4625318 15.6082954,20.6584043 14.1675223,20.7449812 L14,20.75 L4,20.75 C2.53746816,20.75 1.34159572,19.6082954 1.25501879,18.1675223 L1.25,18 L1.25,4.75 L0,4.75 C-0.414213562,4.75 -0.75,4.41421356 -0.75,4 C-0.75,3.62030423 -0.467846118,3.30650904 -0.101770557,3.25684662 L0,3.25 L4.25,3.25 L4.25,2 C4.25,0.537468162 5.3917046,-0.658404279 6.83247767,-0.744981206 L7,-0.75 L11,-0.75 Z M15.25,4.75 L2.75,4.75 L2.75,18 C2.75,18.6472087 3.24187466,19.1795339 3.87219476,19.2435464 L4,19.25 L14,19.25 C14.6472087,19.25 15.1795339,18.7581253 15.2435464,18.1278052 L15.25,18 L15.25,4.75 Z M7,8.25 C7.37969577,8.25 7.69349096,8.53215388 7.74315338,8.89822944 L7.75,9 L7.75,15 C7.75,15.4142136 7.41421356,15.75 7,15.75 C6.62030423,15.75 6.30650904,15.4678461 6.25684662,15.1017706 L6.25,15 L6.25,9 C6.25,8.58578644 6.58578644,8.25 7,8.25 Z M11,8.25 C11.3796958,8.25 11.693491,8.53215388 11.7431534,8.89822944 L11.75,9 L11.75,15 C11.75,15.4142136 11.4142136,15.75 11,15.75 C10.6203042,15.75 10.306509,15.4678461 10.2568466,15.1017706 L10.25,15 L10.25,9 C10.25,8.58578644 10.5857864,8.25 11,8.25 Z M11,0.75 L7,0.75 C6.35279131,0.75 5.8204661,1.24187466 5.75645361,1.87219476 L5.75,2 L5.75,3.25 L12.25,3.25 L12.25,2 C12.25,1.35279131 11.7581253,0.820466101 11.1278052,0.756453609 L11,0.75 Z"
                          id="Combined-Shape"
                        ></path>
                      </g>
                    </g>
                  </svg>
                </div>
              </div>
            </div>
          </div>
          <div class="card-comment">
            <div class="comment-image-container">
              <figure class="image comment-image">
                <img
                  class="is-rounded"
                  v-lazysizes
                  :src="
                    currentUserAvatar !== '' && currentUserAvatar
                      ? currentUserAvatar
                      : defaultImage
                  "
                  style="object-fit: cover; height: 22px"
                />
              </figure>
            </div>
            <div
              class="card-comment-input"
              :style="
                commentFocus
                  ? { border: '0.5px solid #D0D0D0', borderRadius: '6px' }
                  : {}
              "
            >
              <div
                style="
                  margin: 0;
                  padding: 0;
                  min-height: 40px;
                  display: flex;
                  align-items: center;
                  width: 100%;
                "
              >
                <!-- <label :style="lang === 'ar'? {color: '#979797!important',right: 0, left: 'auto'}:{color: '#979797!important',left: '0',right: 'auto'}">{{$t('CommentPlaceholder')}}</label> -->
                <textarea
                  :placeholder="$t('CommentPlaceholder')"
                  @focus="focusHandler"
                  ref="comment"
                  rows="1"
                  md-autogrow
                  style="
                    color: #101010;
                    width: 100%;
                    border: none;
                    resize: none;
                    min-height: 32px;
                    max-height: 230px;
                    padding: 5px 0;
                    line-height: 1.3em;
                    outline: none;
                  "
                ></textarea>
              </div>
              <!-- <textarea class="textarea" id="standard-basic" :placeholder="$t('CommentPlaceholder')"  ref="comment" rows="1" :style="{borderColor: color}"></textarea> -->
              <div
                class="card-comment-button"
                v-if="commentFocus"
                @click="() => newComment(video._id)"
              >
                <div :style="{ color: bkColor, fontWeight: 700 }">
                  {{ $t("CommentSend") }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal is-active is-clipped" v-if="shareModal">
      <div class="modal-card" :style="height">
        <section
          class="modal-body"
          style="
            position: relative;
            padding: 0;
            background-color: rgba(0, 0, 0, 0.5);
          "
        >
          <div
            class="modal-card-content"
            style="
              position: absolute;
              bottom: 0;
              width: 100%;
              height: 230px;
              background-color: #fff;
            "
          >
            <div class="container" style="height: 100%">
              <div class="row">
                <div class="col-12" style="margin: 20px auto">
                  <div class="share-modal-button">
                    <div class="card-share-button" @click="openAllShare">
                      <span
                        style="font-family: Cairo;font-size: 16px;font-weight: bold;letter-spacing: 0;line-height: 30px;text-align: center;"
                        >{{ $t("sharingLink") }}</span
                      >
                      <div
                        style="background-color: #313131; padding: 8px;border-radius: 50%;width: 50px;height: 50px;margin: 10px auto;"
                      >
                        <svg
                          fill="none"
                          stroke="#fff"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"
                          />
                          <path
                            d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"
                          />
                        </svg>
                        <!-- <img :src="shareImg" alt="share" style="width:18px" > -->
                        <!-- <i class="fas fa-share-alt" :style="{color:color, fontSize: '20px'}" @click="shareMethod(video._id)"></i> -->
                      </div>
                    </div>
                    <div class="card-share-button" @click="instagramShare">
                      <span
                        style="font-family: Cairo;font-size: 16px;font-weight: bold;letter-spacing: 0;line-height: 30px;text-align: center;"
                        >{{ $t("sharingPost") }}</span
                      >
                      <div
                        style="background-color: #313131; padding: 8px;border-radius: 50%;width: 50px;height: 50px;margin: 10px auto;"
                      >
                        <svg
                          viewBox="0 0 32 32"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <title />
                          <g
                            fill="none"
                            stroke="#fff"
                            stroke-linejoin="round"
                            stroke-width="2px"
                          >
                            <polygon points="10 1 4 7 4 31 28 31 28 1 10 1" />
                            <polyline points="10 1 10 7 4 7" />
                            <rect
                              class="cls-1"
                              height="10"
                              width="14"
                              x="9"
                              y="15"
                            />
                            <polyline points="9 25 14 20 19 25" />
                            <polyline points="16 22 18 20 23 25" />
                          </g>
                        </svg>
                      </div>
                    </div>
                  </div>
                  <div class="share-modal-cancel">
                    <button
                      class="btn back"
                      :style="cssVariable"
                      @click="shareModal = false"
                    >
                      {{ $t("cancelButton") }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import TimeAgo from "javascript-time-ago";
import en from "javascript-time-ago/locale/en";
import ar from "javascript-time-ago/locale/ar";
import MoreComments from "./MoreComments.vue";
export default {
  name: "card",
  data() {
    return {
      isOpen: false,
      modalOpen: false,
      shareModal: false,
      shareUrl: null,
      commentFocus: false,
      commentSend: false
    };
  },
  props: [
    "video",
    "index",
    "clickLike",
    "submitNewComment",
    "isRanking",
    "reportHandler",
    "deleteHandler",
    "currentUser"
  ],
  components: { MoreComments },
  computed: {
    height() {
      return {
        "--height": this.$store.getters.screenHeight + "px"
      };
    },
    screenHeight() {
      return this.$store.getters.screenHeight - 100;
    },
    defaultImage() {
      return this.$store.getters.brandLogo;
    },
    competitionId() {
      return this.$store.getters.competitionId;
    },
    rankingNum() {
      return parseInt(this.index) + 1;
    },
    lang() {
      return this.$store.getters.lang;
    },
    color() {
      return this.$store.getters.primaryColor;
    },
    bkColor() {
      return this.$store.getters.secondaryColor;
    },
    cssVariable() {
      return {
        "--color": this.$store.getters.primaryColor,
        "--bkcolor": this.$store.getters.secondaryColor
      };
    },
    currentUserAvatar() {
      return this.$store.getters.currentUserAvatar;
    },
    shareMessageEn() {
      return this.$store.getters.shareMessageEn;
    },
    shareMessageAr() {
      return this.$store.getters.shareMessageAr;
    },
    socialQuoteEn() {
      return this.$store.getters.socialQuoteEn;
    },
    socialQuoteAr() {
      return this.$store.getters.socialQuoteAr;
    },
    socialHashtag() {
      return this.$store.getters.socialHashtag;
    }
  },
  created() {
    localStorage.removeItem("shareResult");
    localStorage.removeItem("shareId");
  },
  mounted() {
    window.addEventListener("storage", this.shareResult);
  },
  beforeDestroy() {
    window.removeEventListener("storage", this.shareResult);
  },
  methods: {
    userImageErrorHandler(e) {
      e.target.src = this.defaultImage;
    },
    followHandler(id) {
      this.$store.dispatch("followHandler", id);
    },
    shareResult() {
      let shareR = localStorage.getItem("shareResult");
      let shareId = localStorage.getItem("shareId");
      if (shareR === null) {
        return false;
      } else {
        this.$store.dispatch("shareHandler", {
          shareResult: shareR,
          id: shareId
        });
        localStorage.removeItem("shareResult");
      }
    },
    deleteMethod(id) {
      this.isOpen = false;
      this.deleteHandler(id);
    },
    reportMethod(id) {
      this.isOpen = false;
      this.reportHandler(id);
    },
    openAllShare() {
      const quote =
        this.lang === "ar" ? this.socialQuoteAr : this.socialQuoteEn;
      const copiedMessage =
        this.lang === "ar" ? this.shareMessageAr : this.shareMessageEn;
      const hashtag = this.socialHashtag;
      const input = document.createElement("textarea");
      document.body.appendChild(input);
      input.value = `#${hashtag}\n${quote}`;
      input.focus();
      input.select();

      const isSuccessful = document.execCommand("copy");

      if (isSuccessful) {
        notie.force(
          {
            text: copiedMessage
          },
          () => {
            if (typeof window.ReactNativeWebView !== "undefined") {
              const shareObject = { url: this.shareUrl };
              window.ReactNativeWebView.postMessage(
                JSON.stringify(shareObject)
              );
            } else {
              navigator
                .share(
                  {
                    title: quote,
                    text: quote,
                    url: this.shareUrl,
                    // extra, optional options
                    fbId: "1958558457798463",
                    hashtags: [hashtag]
                  },
                  {
                    // change this configurations to hide specific unnecessary icons
                    copy: true,
                    email: true,
                    print: true,
                    sms: true,
                    messenger: true,
                    facebook: true,
                    whatsapp: true,
                    twitter: true,
                    linkedin: true,
                    telegram: true,
                    skype: true,
                    language: "en" // specify the default language
                  }
                )
                .then(() => {
                  localStorage.setItem("shareResult", true);
                  var evt = document.createEvent("StorageEvent");
                  evt.initStorageEvent(
                    "storage",
                    false,
                    false,
                    "key",
                    "oldValue",
                    "newValue",
                    "*",
                    window.localStorage
                  );
                  window.dispatchEvent(evt);
                })
                .catch(error => {
                  {
                    localStorage.setItem("shareResult", false);
                    var evt = document.createEvent("StorageEvent");
                    evt.initStorageEvent(
                      "storage",
                      false,
                      false,
                      "key",
                      "oldValue",
                      "newValue",
                      "*",
                      window.localStorage
                    );
                    window.dispatchEvent(evt);
                  }
                });
            }
          }
        );
      }
      document.body.removeChild(input);
    },
    instagramShare() {
      const quote =
        this.lang === "ar" ? this.socialQuoteAr : this.socialQuoteEn;
      const hashtag = this.socialHashtag;

      let videoImg;
      const url = `https://api.vimeo.com/videos/${this.video.uri}/pictures`;
      axios
        .get(url, {
          headers: {
            "Content-Type": "application/json",
            Authorization: "bearer c45bc0c3d9cfb0cd1e56ba3f84ca84d0"
          }
        })
        .then(res => {
          const imgs = res.data.data[0].sizes;
          videoImg = imgs[Math.floor(imgs.length / 2)];
          fetch(videoImg.link)
            .then(response => {
              return response.blob();
            })
            .then(blob => {
              var file = new File([blob], "picture.jpg", {
                type: "image/jpeg"
              });
              var filesArray = [file];
              const quote =
                this.lang === "ar" ? this.socialQuoteAr : this.socialQuoteEn;
              const copiedMessage =
                this.lang === "ar" ? this.shareMessageAr : this.shareMessageEn;
              const hashtag = this.socialHashtag;
              const input = document.createElement("textarea");
              document.body.appendChild(input);
              input.value = `#${hashtag}\n${quote}\n${this.shareUrl}`;
              input.focus();
              input.select();

              const isSuccessful = document.execCommand("copy");

              if (isSuccessful) {
                notie.force(
                  {
                    text: copiedMessage
                  },
                  () => {
                    try {
                      navigator
                        .share({
                          title: quote,
                          text: quote,
                          url: this.shareUrl,
                          files: filesArray,
                          hashtags: [hashtag]
                        })
                        .then(() => {
                          localStorage.setItem("shareResult", true);
                          var evt = document.createEvent("StorageEvent");
                          evt.initStorageEvent(
                            "storage",
                            false,
                            false,
                            "key",
                            "oldValue",
                            "newValue",
                            "*",
                            window.localStorage
                          );
                          window.dispatchEvent(evt);
                        })
                        .catch(error => {
                          {
                            localStorage.setItem("shareResult", false);
                            var evt = document.createEvent("StorageEvent");
                            evt.initStorageEvent(
                              "storage",
                              false,
                              false,
                              "key",
                              "oldValue",
                              "newValue",
                              "*",
                              window.localStorage
                            );
                            window.dispatchEvent(evt);
                          }
                        });
                    } catch (err) {
                      console.log(err);
                    }
                  }
                );
              }
              document.body.removeChild(input);
            });
        })
        .catch(err => console.log("error", err));
    },
    shareMethod(id) {
      if (this.video.isApproved) {
        let result = bowser.getParser(window.navigator.userAgent);
        let src = sessionStorage.getItem("src");
        let standalone = window.navigator.standalone,
          userAgent = window.navigator.userAgent.toLowerCase(),
          safari = /safari/.test(userAgent),
          ios = /iphone|ipod|ipad/.test(userAgent);
        this.isOpen = false;
        localStorage.setItem("shareId", id);
        window.addEventListener("storage", this.shareResult);
        this.shareUrl = process.env.VUE_APP_API_SHARE_URL + id;

        if (result.parsedResult.browser.name === "Firefox") {
          // firefox not working at all
          let message = "";
          let lang = localStorage.getItem("lang");
          if (lang === "0") {
            message =
              "Error !!! Please use different browser so you can share this video ";
          } else {
            message =
              "خطأ !!! الرجاء استخدام متصفح مختلف حتى تتمكن من مشاركة هذا الفيديو";
          }
          notie.alert({ type: "error", text: message });
        } else if (!ios && !userAgent.includes("wv")) {
          //for the chrome on web or chrome on the mobile
          this.shareModal = true;
        } else {
          //for the webviews and the ios
          this.openAllShare();
        }
      } else {
        let message = "";
        let lang = localStorage.getItem("lang");
        if (lang === "0") {
          message = "Video sharing is disabled until video approval";
        } else {
          message = "الشير موقوف لحين الموافقه علي الفيديو ..";
        }
        notie.alert({ type: "error", text: message });
      }
    },
    closeModal() {
      this.modalOpen = false;
    },
    getTime(time) {
      if (time === "") {
        return "";
      } else {
        var ts = new Date(time);
        if (this.lang === "ar") {
          TimeAgo.addLocale(ar);
          const timeAgo = new TimeAgo("ar-EG");
          return timeAgo.format(ts);
        } else {
          TimeAgo.addLocale(en);
          const timeAgo = new TimeAgo("en-Us");
          return timeAgo.format(ts);
        }
      }
    },
    focusHandler() {
      this.commentFocus = true;
    },
    newComment(id) {
      this.commentFocus = false;
      this.submitNewComment({ value: this.$refs.comment.value, id });
      this.$refs.comment.value = "";
    },
    lastCommentDelete(comment_id, video_id) {
      this.$store.dispatch("deleteLastcommentHandler", {
        comment_id,
        video_id
      });
    }
  },
  filters: {
    arabicize: function(value) {
      const arabicNums = ["٠", "١", "٢", "٣", "٤", "٥", "٦", "٧", "٨", "٩"];
      if (value) {
        return value.toString().replace(/[0-9]/g, function(w) {
          return arabicNums[+w];
        });
      } else {
        return arabicNums[0];
      }
    }
  }
};
</script>

<style scoped>
/* card Title */
.card-user-name {
  width: 85%;
  display: inline-block;
  text-align: start;
  margin-bottom: 5px;
}
.card-main-title {
  color: #101010;
  font-family: Cairo;
  font-size: 15px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 29px;
  display: block;
}
.card-title {
  color: #313131;
}
.user-image {
  width: 45px;
  height: 45px;
  display: inline-block;
  margin: 0 !important;
}
.card-main-image {
  width: 15%;
  display: block;
  margin: 0 5px;
}
.share-buttons {
  display: inline-block;
}
.share-buttons i {
  margin: 0 3px;
}
.card-edit-menu {
  width: 5%;
  display: inline-block;
  margin: 0 10px;
}
/* card body */
.card-body {
  padding: 0.3rem;
}
/* video section */
.ribbon-right {
  width: auto;
  height: 34px;
  position: absolute;
  right: 10px;
  top: 10px;
  z-index: 10;
  padding: 5px 8px;
  border-radius: 15px;
  text-align: left;
  background-color: rgba(17, 17, 17, 0.8);
  text-align: start;
}
.ribbon-left {
  width: auto;
  height: 34px;
  position: absolute;
  left: 10px;
  top: 10px;
  z-index: 10;
  padding: 5px 8px;
  border-radius: 15px;
  text-align: left;
  background-color: rgba(17, 17, 17, 0.8);
  text-align: start;
}
.ribbon-text {
  color: #ffffff;
  font-family: Cairo;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 17px;
  margin: 0 3px;
}
.card-video-approved {
  position: absolute;
  bottom: 20px;
  left: 2%;
  text-align: center;
  width: 96%;
  background-color: #313131;
}
.card-video-approved div {
  color: var(--color);
  font-size: 1.8rem;
  font-weight: 500;
}
.card-video-featured {
  position: absolute;
  z-index: 15;
  top: 10px;
  width: 30px;
  height: 30px;
}
/* caption section  */
.card-caption {
  margin: 8px 20px;
  min-height: 20px;
  text-align: start;
}
/* buttons sections (like,share) */
.card-action-buttons {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  margin: 0 20px;
}
.card-like-button {
  text-align: start;
}
.card-like-number {
  color: #101010;
  font-family: Cairo;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0;
  line-height: 23px;
}
.card-follow-button {
  text-align: start;
}
.card-follow-number {
  color: #101010;
  font-family: Cairo;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0;
  line-height: 23px;
}
.card-share-button {
  text-align: start;
}
/* last comment section */
.card-last-comment-container {
  margin: 10px auto;
}

.card-last-comment-title {
  display: block;
  margin: 0 20px;
}
.card-last-comment-name {
  display: inline-block;
}
.card-last-comment-text {
  display: inline-block;
  color: #101010;
  font-family: Cairo;
  font-size: 13px;
  letter-spacing: 0.19px;
  line-height: 19px;
  word-wrap: break-word;
}
.card-last-comment-name {
  color: #101010;
  font-family: Cairo;
  font-size: 13px;
  letter-spacing: 0.19px;
  line-height: 19px;
  font-weight: 900;
}
.last-comment-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0px 20px;
}
.last-comment-time {
  display: inline-block;
  width: auto;
}
.last-comment-time div {
  color: #8e8e8e;
  font-family: Cairo;
  font-size: 12px;
  font-weight: 400;
}
.last-comment-delete {
  display: inline-block;
  margin: 0 10px;
  width: 20px;
  height: 20px;
}
.more-comments-view {
  margin: 15px 20px;
  text-align: start;
}
.more-comments-text {
  color: #8e8e8e;
  font-family: Cairo;
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 0.21px;
  line-height: 29px;
}
/* comments now section */
.card-comment {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 0 20px;
  margin-bottom: 5px;
}
.comment-image-container {
  width: auto;
  display: inline-block;
}
.comment-image {
  width: 22px;
  height: 22px;
  display: inline-block;
  margin: 0 !important;
}
.card-comment-input {
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin: 0 5px;
  padding: 0 10px;
}
.card-comment-button {
  width: 40px;
}
.comment-button {
  background: transparent !important;
  margin: 0 10px !important;
}
.share-modal-close {
  width: 90%;
  margin: 15px;
  display: flex;
  flex-direction: row-reverse;
  justify-content: flex-start;
  align-items: center;
}
.share-modal-button {
  margin: 20px auto;
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 100%;
}
.share-modal-cancel {
  text-align: center;
}
.share-modal-cancel .back {
  width: 50%;
  border-radius: 6px;
  background-color: #d83c3e;
  color: #ffffff;
  font-family: Cairo;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 30px;
  text-align: center;
}
.modal-card-close {
  color: #d83c3e;
  font-family: Cairo;
  font-size: 15px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 29px;
  text-align: right;
}
</style>
